import { isNil } from "lodash";
import { UTCDate } from "./date";

export function calculateAge(birthDate: UTCDate | null): number | null {
  const referenceDate = UTCDate.today();
  if (isNil(birthDate) || birthDate > referenceDate) {
    return null;
  }

  const birthYear = birthDate.getFullYear();
  const birthMonth = birthDate.getMonth();
  const birthDay = birthDate.getDate();

  const refYear = referenceDate.getFullYear();
  const refMonth = referenceDate.getMonth();
  const refDay = referenceDate.getDate();

  const age = refYear - birthYear;
  if (refMonth > birthMonth) {
    return age;
  }

  if (refMonth === birthMonth && refDay >= birthDay) {
    return age;
  }

  return age - 1;
}
